(() => {
  const selector = '.night-shift-first-30-days';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(section) {
    section.classList.add('is-revealed');
  }

  function init(section) {
    if (!section || section.dataset.first30DaysAnimationInitialized === 'true') return;

    section.dataset.first30DaysAnimationInitialized = 'true';

    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveal(section);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        reveal(section);
        observer.unobserve(section);
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    observer.observe(section);
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
